/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, June 30th 2022, 4:33:21 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useGlobalScope } from "core/providers";
import { OrganizationFormPage } from "./OrganizationFormPage";

export const EditSelectedOrganizationPage = () => {
  const {
    globalState: { selectedOrganization },
  } = useGlobalScope();

  return <OrganizationFormPage organizationId={selectedOrganization.id} />;
};
